import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProjectPage, ModalAddProjectPage } from './project';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    ProjectPage,
    ModalAddProjectPage,
  ],
  imports: [
    IonicPageModule.forChild(ProjectPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
    ModalAddProjectPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class ProjectPageModule {}



// WEBPACK FOOTER //
// ./src/pages/project/project.module.ts